import type { $Fetch } from 'ofetch'

class HttpFactory<T> {
  private $fetch: $Fetch

  constructor(fetcher: $Fetch) {
    this.$fetch = fetcher
  }

  /**
   * method - GET, POST, PUT
   * URL
   **/
  async call<T>(method: string, url: string, data?: object, extras?: object, signal?: AbortSignal): Promise<any> {
    try {
      const $res: T = await this.$fetch(url, { signal, method, body: data, ...extras })
        .then((response) => {
          return response
        })
        .catch((error) => {
          return Promise.reject(error)
        })

      return $res
    } catch (error: any) {
      console.error(error, url)
      if (error?.status === 401) return error
      else throw error
    }
  }
}

export default HttpFactory
